import { endAt, get, orderByKey, query, ref, startAt } from "firebase/database";
import { db } from "../lib/firebase";
import { LaunchError } from "../utils/errors";

const AD_SPEND_STATS_PATH = "adSpendStats";

// The page renders one inline error for the whole report, so reads skip the
// global alert to avoid one toast per parallel read.
const readFailure = async ({ dispatch, error, functionName, operation }) => {
  const errorFormatted = await dispatch(
    LaunchError(error, false, [], {
      functionName,
      tags: { operation },
    })
  );
  return {
    ok: false,
    message: errorFormatted?.message,
    code: errorFormatted?.code,
  };
};

const readNode = async ({ source, emptyValue }) => {
  const snapshot = await get(source);
  return snapshot.exists() ? snapshot.val() : emptyValue;
};

const keyRangeQuery = ({ path, from, to }) =>
  query(ref(db, path), orderByKey(), startAt(from), endAt(to));

export const startGetAdSpendAllTime = () => async (dispatch) => {
  try {
    const data = await readNode({
      source: ref(db, `${AD_SPEND_STATS_PATH}/allTime`),
      emptyValue: null,
    });
    return { ok: true, data };
  } catch (error) {
    return readFailure({
      dispatch,
      error,
      functionName: "startGetAdSpendAllTime",
      operation: "get_ad_spend_all_time",
    });
  }
};

export const startGetAdSpendMonthly =
  ({ from, to }) =>
  async (dispatch) => {
    try {
      const data = await readNode({
        source: keyRangeQuery({
          path: `${AD_SPEND_STATS_PATH}/monthly`,
          from,
          to,
        }),
        emptyValue: {},
      });
      return { ok: true, data };
    } catch (error) {
      return readFailure({
        dispatch,
        error,
        functionName: "startGetAdSpendMonthly",
        operation: "get_ad_spend_monthly",
      });
    }
  };

export const startGetAdSpendDaily =
  ({ from, to }) =>
  async (dispatch) => {
    try {
      const data = await readNode({
        source: keyRangeQuery({
          path: `${AD_SPEND_STATS_PATH}/daily`,
          from,
          to,
        }),
        emptyValue: {},
      });
      return { ok: true, data };
    } catch (error) {
      return readFailure({
        dispatch,
        error,
        functionName: "startGetAdSpendDaily",
        operation: "get_ad_spend_daily",
      });
    }
  };

export const startGetAdSpendSeries =
  ({ granularity, from, to }) =>
  async (dispatch) => {
    try {
      const path = `${AD_SPEND_STATS_PATH}/series/${granularity}`;
      const data = await readNode({
        source:
          from == null || to == null
            ? ref(db, path)
            : keyRangeQuery({ path, from, to }),
        emptyValue: {},
      });
      return { ok: true, data };
    } catch (error) {
      return readFailure({
        dispatch,
        error,
        functionName: "startGetAdSpendSeries",
        operation: "get_ad_spend_series",
      });
    }
  };

export const startGetAdSpendAdvertisersMeta = () => async (dispatch) => {
  try {
    const data = await readNode({
      source: ref(db, `${AD_SPEND_STATS_PATH}/advertisersMeta`),
      emptyValue: {},
    });
    return { ok: true, data };
  } catch (error) {
    return readFailure({
      dispatch,
      error,
      functionName: "startGetAdSpendAdvertisersMeta",
      operation: "get_ad_spend_advertisers_meta",
    });
  }
};
